import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import range from 'lodash/range';
import classnames from 'classnames';

import { getRoundedStarRating } from 'utils/rating';
import Star from './Star';

import './stars.scss';

/**
 * Renders a series of stars to represent the rating/outOf values
 */
function Stars({
	className, outOf, rating
}) {
	return (
		<span className={classnames(className, 'stars')}>
			{map(range(0, outOf), (starValue) => (
				<Star
					key={starValue}
					value={getRoundedStarRating(rating - starValue)}
				/>
			))}
		</span>
	);
}

Stars.propTypes = {
	className: PropTypes.string,
	/** The rating to show */
	rating: PropTypes.number,
	/** What the rating is out of */
	outOf: PropTypes.number,
};

Stars.defaultProps = {
	rating: 0,
	outOf: 5,
};

export default Stars;
